// C:\Users\Caner\inosel-panel\ortak\src\fatura-takip\src\Main.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./components/AuthContext";

import Navbar from "./components/Navbar";
import FaturaGirisi from "./pages/FaturaGirisi";
import KategoriYonetimi from "./pages/KategoriYonetimi";
import Raporlar from "./pages/Raporlar";
import FirmaYonetimi from "./pages/FirmaYonetimi";
import FaturaListesi from "./pages/FaturaListesi";
import FaturaExcelYukle from "./pages/FaturaExcelYukle";
import FaturaDuzenle from "./pages/FaturaDuzenle";
import OnarimKararDestek from "./pages/OnarimKararDestek";
import AdminPage from "./pages/AdminPage";
import FirmaExcelYukle from "./pages/FirmaExcelYukle";
import PrivateRoute from "./components/PrivateRoute";
import KategoriExcelYukle from "./pages/KategoriExcelYukle";

const FaturaRoutes = () => {
  const { user, role, loading } = useAuth();

  if (loading) return <div className="text-center mt-10">Yükleniyor...</div>;
  if (!user || !role) return <Navigate to="/giris" replace />;

  const getDefaultRoute = () => {
    if (["yetkili", "yonetici", "oluşturucu"].includes(role)) return "fatura-girisi";
    return "giris";
  };

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Navigate to={getDefaultRoute()} replace />} />

        {/* TAKİP gerektiren sayfalar */}
        <Route
          path="fatura-girisi"
          element={
            <PrivateRoute izin="takip">
              <FaturaGirisi />
            </PrivateRoute>
          }
        />
        <Route
          path="onarim-karar-destek"
          element={
            <PrivateRoute izin="takip">
              <OnarimKararDestek />
            </PrivateRoute>
          }
        />
        <Route
          path="faturalar"
          element={
            <PrivateRoute izin="takip">
              <FaturaListesi />
            </PrivateRoute>
          }
        />
        <Route
          path="raporlar"
          element={
            <PrivateRoute izin="takip">
              <Raporlar />
            </PrivateRoute>
          }
        />

        {/* ⬇️ BUNLARI "yonetici" yerine "takip" yaptık (takip: true erişebilsin) */}
        <Route
          path="fatura-duzenle"
          element={
            <PrivateRoute izin="takip">
              <FaturaDuzenle />
            </PrivateRoute>
          }
        />
        <Route
          path="firma-yonetimi"
          element={
            <PrivateRoute izin="takip">
              <FirmaYonetimi />
            </PrivateRoute>
          }
        />
        <Route
          path="kategoriler"
          element={
            <PrivateRoute izin="takip">
              <KategoriYonetimi />
            </PrivateRoute>
          }
        />

        {/* ⬇️ EXCEL sayfaları sadece fatura.yonetici: true */}
        <Route
          path="fatura-excel-yukle"
          element={
            <PrivateRoute izin="fatura.yonetici">
              <FaturaExcelYukle />
            </PrivateRoute>
          }
        />
        <Route
          path="firma-excel-yukle"
          element={
            <PrivateRoute izin="fatura.yonetici">
              <FirmaExcelYukle />
            </PrivateRoute>
          }
        />
        <Route
          path="kategori-excel-yukle"
          element={
            <PrivateRoute izin="fatura.yonetici">
              <KategoriExcelYukle />
            </PrivateRoute>
          }
        />

        {/* Admin: sadece global oluşturucu */}
        <Route
          path="admin"
          element={
            <PrivateRoute izin="olusturucu">
              <AdminPage />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<Navigate to={getDefaultRoute()} replace />} />
      </Routes>
    </>
  );
};

const Main = () => {
  return (
    <AuthProvider>
      <FaturaRoutes />
    </AuthProvider>
  );
};

export default Main;
